import React, { Component } from 'react'
import Arrow from 'material-ui/svg-icons/hardware/keyboard-arrow-right'
import Toggle from 'material-ui/Toggle'
import FlatButton from 'material-ui/FlatButton'
import { Link } from 'react-router-dom'
import StripeCheckout from 'react-stripe-checkout'
import { FormattedMessage } from 'react-intl'
import Plans from './Plans'
import config from '../../config/config'
import { getCustomer, getPlan, isSentry } from '../../lib'

class ManagePlans extends Component {
  state = {
    planSwitched: false,
    plan: '',
    card: '',
  }

  componentDidMount = async () => {
    const plan = await getPlan()
    this.setState({
      plan: plan
    })

    console.log(plan)
    if (plan == 'premium' || this.props.stripeAccount) {
      try {
        const customer = (await getCustomer()).customer
        this.setState({
          card: customer.sources.data[0],
        })
      } catch (err) {
        console.log(err)
        isSentry(err)
      }
    }

    // TODO: 現在のプランの加入情報を表示する

    // TODO: 現在のクレジットカード情報の番号を取得する

    // TODO: 請求書のリンク情報の取得をする

    // TODO: お問い合わせ情報のリンクを作成する

    // TODO: クレジットでのプランの加入時にローディング画面を表示する

  }

  handleToggle = (e, isToggled) => this.setState({planSwitched: isToggled})
  onToken = (token, price) => this.refs.plans.refs.plan.onToken(token, price)

  render () {
    const {planSwitched} = this.state
    const starterMonthly = '25,000'
    const starterYearly = '240,000'
    const premiumMonthly = '75,000'
    const premiumYearly = '720,000'
    return (
      <div className="pl3 pt3 h-100" style={{color: '#6B7C93'}}>
        {false && <div className="flex items-center mb3">
          <Link
            to={'/admin/settings'}
            className="link">
            <span className="pr2" style={{fontSize: 24, opacity: 0.37}}>
              <FormattedMessage id="mangePlan.settings"/>
            </span>
          </Link>
          <Arrow className="pr2" style={{fill: '#c6ced7'}}/>
          <span style={{fontSize: 24}}>
            <FormattedMessage id="mangePlan.manage"/>
          </span>
        </div>}
        {false && <div className="flex justify-center mb2">
          <span style={{opacity: !planSwitched ? 1 : 0.37}} className="mr3">
            <FormattedMessage id="mangePlan.monthly"/>
          </span>
          <div className="mr3">
            <Toggle onToggle={this.handleToggle} toggled={planSwitched}/>
          </div>
          <span style={{opacity: planSwitched ? 1 : 0.37}}>
            <FormattedMessage id="mangePlan.yearly"/>
          </span>
        </div>}
        <Plans
          email={this.props.email}
          location={this.props.location.pathname}
          stripeAccount={this.props.stripeAccount}
          changePlan={this.props.changePlan}
          returnUserIfUserExists={this.props.returnUserIfUserExists}
          ref="plans"
          isUpdatingPlan={this.props.isUpdatingPlan}
          planerror={this.props.planerror}
          userPlan={this.state.plan}
          starterPrice={!planSwitched ? starterMonthly : starterYearly}
          premiumPrice={!planSwitched ? premiumMonthly : premiumYearly}
          contract={
            !planSwitched
              ? <FormattedMessage id="mangePlan.month" value="month"/>
              : <FormattedMessage id="mangePlan.year" vlaue="year"/>
          }
        />

        <div className="flex justify-between mt3 items-center">
          {this.props.stripeAccount
            ? <div>
              <StripeCheckout
                image={config.ADMIN_URL + '/workshop_icon.png'}
                name="Anet Co.,Ltd."
                panelLabel="カード情報の更新"
                description=""
                email={this.props.email}
                allowRememberMe={false}
                token={token => this.onToken(token, 'update_card')}
                stripeKey={config.STRIPE_KEY}>
                <FlatButton
                  label={<FormattedMessage id="mangePlan.updateCreditCard"/>}
                  hoverColor="#c59d3f"
                  backgroundColor="#f1b62e"
                  labelStyle={{color: '#FFFFFF'}}
                />
              </StripeCheckout>

              <div className="mt3">
                現在のクレジットカード情報: {this.state.card.brand} **** **** ***{this.state.card.last4},
                有効期限 {this.state.card.exp_month}/{this.state.card.exp_year}
              </div>

              <div className="mt3">
                <Link
                  to={'/admin/settings/billing'}
                  className="link mt3">
                    <span className="pr2" style={{fontSize: 18, opacity: 0.37}}>
                      支払い履歴
                    </span>
                </Link>
              </div>
            </div>
            : <div className="w4"/>
          }


          {false && <Link
            to={'/admin/settings/manage-plans/FaQ'}
            className="link">
            <span style={{opacity: 0.37, fontSize: 20}}>
              <FormattedMessage id="mangePlan.FAQ"/>
            </span>
          </Link>}
        </div>


      </div>
    )
  }
}

export default ManagePlans



// WEBPACK FOOTER //
// ./src/routes/ManagePlans/ManagePlans.js